import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=365ade60&"
import script from "./BaseSnackbar.vue?vue&type=script&lang=ts&"
export * from "./BaseSnackbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports